<template>
  <div>
    <div class="com-banner" style="background-image:url(https://fs.58keeper.com/franchise-bg.jpg)">
      <div class="banner-inner center">
        <h1>产品与服务</h1>
        <p>围绕房屋提供一站式配套增值服务，省心省力</p>
      </div>
    </div>
    <div class="section franchise-section">
      <div class="com-container">
        <div class="franchise-content">
          <div class="franchise-txt">
            <h3>大管家PLUS</h3>
            <p>
              房屋一站式智慧托管SaaS管理系统，高效真实、数据透明。<br>
              通过办公移动化、房源管理标准化，实时同步出租记录、打扫养护信息图片。<br>
              数字化运维，工作智能提醒，大数据模型运营，提高出租效率，高效管理房源。<br>
              强大的房东数据后台，房东实时查看房源动态情况，养护经营透明真实可见。
            </p>
          </div>
          <img src="https://fs.58keeper.com/franchise.jpg">
        </div>
        <div class="franchise-list">
          <div class="row">
            <div class="col-md-6">
              <div class="img">
                <img src="https://fs.58keeper.com/franchise1.jpg" alt="多妙">
              </div>
              <h3>多妙旅租</h3>
              <p>精选海南近千套优质房源，提供优质住宿体验，触摸当地风情，成为游客美妙旅程的组成部分</p>
              <p></p>
            </div>
            <div class="col-md-6 mt-30">
              <div class="rightTxt">think deeper</div>
              <div class="img mt-30">
                <img src="https://fs.58keeper.com/franchise2.jpg" alt="多妙">
              </div>
              <h3>配套服务</h3>
              <p>
                以房屋托管和住宿为载体，满足房东和游客来岛后的其他需求<br>
                家政保洁、租车接送、水果特产、游艇户外、房屋买卖等等
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'franchise',
  data: function () {
    return {}
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Franchise.vue